export default __webpack_public_path__ + "locales/pt-BR/DeleteSelfProfileDialog.json?hash=5b8db6a88caa28ada8fef25c640893ec";